import React, { useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const FallbackComponent = ({
  resetError,
  fallbackPage = { path: '/on-tap', title: 'shared.FallbackComponent.onTap' },
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const resetErrorState = useCallback(() => {
    if (typeof resetError === 'function') {
      resetError();
    }
  }, [resetError]);

  const redirectUser = useCallback(
    e => {
      e.preventDefault();
      navigate(fallbackPage.path);
      resetErrorState();
    },
    [navigate, fallbackPage.path, resetErrorState],
  );

  useEffect(() => {
    resetErrorState();
  }, [location, resetErrorState]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      height="1"
    >
      <Typography variant="h4" style={{ fontSize: 28, fontWeight: 500, marginBottom: 10 }}>
        {t('shared.FallbackComponent.somethingWentWrong')}
      </Typography>
      <Link
        onClick={redirectUser}
        component="button"
        color="primary"
        style={{ cursor: 'pointer', fontSize: 22 }}
      >
        {t('shared.FallbackComponent.goToPage', {
          page:
            fallbackPage.title === 'shared.FallbackComponent.onTap'
              ? t(fallbackPage.title)
              : fallbackPage.title,
        })}
      </Link>
    </Box>
  );
};

export default FallbackComponent;
